export default {"src":"/_next/static/media/14-icon.bafbda5a.svg","height":46,"width":40,"blurWidth":0,"blurHeight":0};